import { POSMaterial, POSMaterialSaveObject } from './POSMaterial';

export interface POSMaterialImageSaveObject extends POSMaterialSaveObject {
	id?: number;
	pos_material_id?: number;
	image: string;
	height: number;
	opacity: number;
	description: string;
}

export class POSImageMaterial extends POSMaterial {

	readonly id: number;
	private _image: string;
	private _height: number;
	private _opacity: number;
	private _description: string;

	set image(image: string) {
		this._image = image || null;
	}

	get image(): string {
		return this._image;
	}

	set height(height: number) {
		this._height = height ?? 0.5;
	}

	get height(): number {
		return this._height;
	}

	set opacity(opacity: number) {
		this._opacity = opacity ?? 1;
	}

	get opacity(): number {
		return this._opacity;
	}

	set description(description: string) {
		this._description = description ?? '';
	}

	get description(): string {
		return this._description;
	}

	constructor(params: Partial<POSMaterialImageSaveObject> = {}) {
		super(params);

		this.id = params.pos_material_id ?? params.id;
		this.image = params.image;
		this.height = params.height;
		this.opacity = params.opacity;
		this.description = params.description;
	}

	public copy(): POSImageMaterial {
		return new POSImageMaterial(this.saveObject());
	}

	public saveObject(): POSMaterialImageSaveObject {
		return {
			...super.saveObject(),
			pos_material_id: this.id,
			image: this.image,
			height: this.height,
			opacity: this.opacity,
			description: this.description
		}
	}

	public commonSaveObject(): Partial<POSMaterialImageSaveObject> {
		return {
			name: this.name,
			image: this.image,
			height: this.height,
			width: this.width,
			opacity: this.opacity,
			description: this.description
		}
	}

	public planogramSaveObject(): Partial<POSMaterialImageSaveObject> {
		return {
			pos_material_id: this.id,
			angle: this.angle,
			x: this.x,
			y: this.y
		}
	}
}